import ProgressStatusMedium from './component.styles'
export default ProgressStatusMedium
